import { render } from "./main-settings.vue?vue&type=template&id=e36bfe9a&ts=true"
import script from "./main-settings.ts?vue&type=script&lang=ts"
export * from "./main-settings.ts?vue&type=script&lang=ts"

import "./main-settings.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__